import { render } from "./AddJob.vue?vue&type=template&id=1706b2c7"
import script from "./AddJob.vue?vue&type=script&lang=js"
export * from "./AddJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__